import React, { useState } from 'react';
import CallLink from '../../../common/CallLink';
import PageLoader from '../../../common/PageLoader';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useParams } from 'react-router-dom';
// import { AllPackages, GetOnePackage } from '../../../Redux/actions/HomeAction';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CommonBanner } from '../CommonBanner';
import $, { map, type } from 'jquery';
import 'bootstrap/dist/css/bootstrap.css';
import { GET_ONE_PART_LIST } from '../../../../Redux/Actions/ActionType';
import MapModalForView from '../../../common/Modal/MapModalForView';
import { useTranslation } from 'react-i18next';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
};

const defaultImages = [
  {
    original: 'assets/images/service-provider/rent-car/banner.jpg',
  },
];

const openStatus = ['OPEN', 'مفتوح'];

export default function SparePartShop() {
  const { t, i18n } = useTranslation();
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  const L = (en, ar) => (isRTL ? ar || en : en || ar);
  var singleData = useSelector((state) => state.home.OnePartList)?.data?.[0];
  const dispatch = useDispatch();
  const { partId } = useParams();
  const [mapModalOpen, setMapModalOpen] = useState(false);
  // const data = { packID: id };

  useEffect(() => {
    const fetchDetail = async (data) => {
      try {
        // console.log('fetch data part', data);
        axios

          .get(
            `https://api.carsavenue.com/api/spareParts/listing?sparePartsId=${partId}`,

            config
          )

          .then((res) => {
            console.log('heeee<<<<', res);
            dispatch({
              type: GET_ONE_PART_LIST,
              payload: res.data.response,
            });

            // setgarageDataDetail(res);

            console.log('heeee<<<<', res);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        // Swal.fire('Incorrect Credentials', '', 'error');
      }
    };

    if (partId && partId !== '') fetchDetail({ partId });
    // console.log('home data', garageDataDetail);
  }, [dispatch, partId]);

  if (!singleData) {
    return (
      <>
        {/* <h2>dsdasdfasdf</h2> */}
        <div
          className="text-center text-warning"
          const
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <PageLoader /> <br />
        </div>
      </>
    );
  }

  //Business Media Data, LOGO, BANNER
  const logoData = singleData?.businessMedia?.find(
    (item) => item.mediaType === 'LOGO'
  );

  let bannerImages = defaultImages;

  if (singleData?.businessMedia && singleData.businessMedia.length > 0) {
    const mediaImages = singleData.businessMedia
      .filter(
        (mediaItem) =>
          mediaItem?.media?.path &&
          (mediaItem.mediaType === 'MAIN_BANNER' ||
            mediaItem.mediaType === 'BANNER')
      )
      .sort(
        (a, b) =>
          (a.mediaType === 'MAIN_BANNER' ? 0 : 1) -
          (b.mediaType === 'MAIN_BANNER' ? 0 : 1)
      )
      .map((mediaItem) => ({
        original: mediaItem.media.path,
        thumbnail: mediaItem.media.path,
      }));

    if (mediaImages.length > 0) {
      bannerImages = mediaImages;
    }
  }

  //Business Calendar
  const businessCalendar =
    typeof singleData?.calendar === 'string'
      ? JSON.parse(singleData?.calendar)
      : singleData?.calendar;
  const now = new Date();
  const currentDay = now
    .toLocaleString('en-us', { weekday: 'long' })
    .toUpperCase(); // "MONDAY"

  const currentTime = now.getHours() * 60 + now.getMinutes();

  const timeToMinutes = (timeStr) => {
    const [time, period] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    if (period === 'PM' && hours < 12) hours += 12;
    if (period === 'AM' && hours === 12) hours -= 12;
    return hours * 60 + minutes;
  };

  let isOpen = false;
  let nextActionTime = ''; // Time for the next action

  const todaySchedule = (businessCalendar || {})[currentDay];

  if (todaySchedule) {
    const { status, openTime, endTime } = todaySchedule;

    if (status === 'مفتوح' || status === 'OPEN') {
      // "Open" status
      const openMinutes = timeToMinutes(openTime);
      const closeMinutes = timeToMinutes(endTime);

      if (currentTime >= openMinutes && currentTime <= closeMinutes) {
        isOpen = true;
        nextActionTime = endTime; // Display closing time
      } else if (currentTime < openMinutes) {
        isOpen = false;
        nextActionTime = openTime; // Display opening time
      } else {
        isOpen = false;
        nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display next day's opening time if closed
      }
    } else {
      isOpen = false;
      nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display opening time if closed
    }
  }

  //Location Data
  const gpsData =
    typeof singleData?.gps === 'string'
      ? JSON.parse(singleData?.gps)
      : singleData?.gps;
  const lat = parseFloat((gpsData || {}).lat);
  const lng = parseFloat((gpsData || {}).long);

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  const handleCloseMap = () => {
    setMapModalOpen(false);
  };

  //Social Media Data
  const socialMediaData =
    typeof singleData?.socialMedia === 'string'
      ? JSON.parse(singleData?.socialMedia)
      : singleData?.socialMedia;

  return (
    <div>
      <div class="user-banner">
        <CommonBanner bannerImages={bannerImages} />

        <div class="user-logo-holder">
          <div class="container">
            <div class="user-logo-holder-wrap">
              <div class="row align-items-center justify-content-between">
                <div class="col-12 col-sm-12 col-md-6 mb-3 mb-sm-3 mb-md-0">
                  <div class="row align-items-center">
                    <img
                      src={logoData?.media?.path || ''}
                      alt=""
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          'assets/images/service-provider/car-dealers/logo.jpg';
                      }}
                      className="max-w-2 max-h-2 rounded-full"
                      style={{
                        width: '140px',
                        height: '140px',
                        objectFit: 'contain',
                        backgroundColor: '#fff',
                      }}
                    />

                    <div class="col-8 col-sm-8 col-md-auto">
                      <h5 class="mb-3">
                        {singleData?.sparePartOwnerName} {singleData?.category}
                      </h5>
                      <ul class="list-inline mb-0 wpm">
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Calendar"
                        >
                          <a
                            href="javascript:void(0);"
                            data-toggle="modal"
                            data-target="#calendar-modal"
                          >
                            <i class="far fa-calendar-alt"></i>
                          </a>
                        </li>

                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Whatsapp"
                        >
                          <a
                            target="_blank"
                            href={`https://wa.me/${`${singleData?.whatsAppNumberCountryCode}${singleData?.whatsAppNumber}`.replace(/\D/g, '')}`}
                          >
                            <i class="fab fa-whatsapp"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Call"
                        >
                          <CallLink
                            record={singleData}
                          >
                            <i class="fas fa-phone"></i>
                          </CallLink>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Location Map"
                        >
                          <a href="javascript:void(0);" onClick={handleOpenMap}>
                            <i class="fas fa-map-marker-alt"></i>
                          </a>
                          <MapModalForView
                            open={mapModalOpen}
                            handleClose={handleCloseMap}
                            currentLocation={{
                              lat: lat,
                              long: lng,
                            }}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-12 col-md-auto">
                  {(isOpen || (nextActionTime && `${nextActionTime}`.trim() !== '')) && (
                    <p class="mb-3">
                    <span class={isOpen ? 'open-time' : 'close-time'}>
                      {isOpen ? t('Open Now') : t('Close Now')}
                    </span>{' '}
                    |{' '}
                    <span class={isOpen ? 'close-time' : 'open-time'}>
                      {isOpen
                        ? `${t('Closes at')} ${nextActionTime}`
                        : `${t('Open at')} ${nextActionTime}`}
                    </span>
                  </p>
                  )}
                  <ul className="list-inline mb-0">
                    {socialMediaData?.INSTAGRAM && (
                      <li className="list-inline-item">
                        <a href={socialMediaData?.INSTAGRAM}>
                          <img
                            src="assets/images/service-provider/instagram.png"
                            alt="Instagram"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.FACEBOOK && (
                      <li className="list-inline-item">
                        <a href={socialMediaData?.FACEBOOK}>
                          <img
                            src="assets/images/service-provider/facebook.png"
                            alt="Facebook"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.TWITTER && (
                      <li className="list-inline-item">
                        <a href={socialMediaData?.TWITTER}>
                          <img
                            src="assets/images/service-provider/twitter.png"
                            alt="Twitter"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.LINKEDIN && (
                      <li className="list-inline-item">
                        <a href={socialMediaData?.LINKEDIN}>
                          <img
                            src="assets/images/service-provider/linkedin.png"
                            alt="Linkedin"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.YOUTUBE && (
                      <li className="list-inline-item">
                        <a href={socialMediaData?.YOUTUBE}>
                          <img
                            src="assets/images/service-provider/youtube.png"
                            alt="Youtube"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.SNAPCHAT && (
                      <li className="list-inline-item">
                        <a href={socialMediaData?.SNAPCHAT}>
                          <img
                            src="assets/images/service-provider/snapchat.png"
                            alt="Snapchat"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.GOOGLEPLUS && (
                      <li className="list-inline-item">
                        <a href={socialMediaData?.GOOGLEPLUS}>
                          <img
                            src="assets/images/service-provider/google-plus.png"
                            alt="Google Plus"
                          />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>

              {/* <!-- CALENDAR  MODAL --> */}
              <div
                class="modal fade"
                id="calendar-modal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">{t('Timing')}</h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <table class="table table-bordered table-striped">
                        <tbody>
                          <tr>
                            <td scope="col">{t('Day')}</td>
                            <td scope="col">{t('Open')}</td>
                            <td scope="col">{t('Close')}</td>
                          </tr>
                          {[
                            'SUNDAY',
                            'MONDAY',
                            'TUESDAY',
                            'WEDNESDAY',
                            'THURSDAY',
                            'FRIDAY',
                            'SATURDAY',
                          ].map((day) => {
                            const status = openStatus.includes(
                              businessCalendar?.[day]?.status
                            );

                            return status ? (
                              <tr>
                                <td scope="col">{t(day)}</td>
                                <td scope="col">
                                  {businessCalendar?.[day]?.openTime}
                                </td>
                                <td scope="col">
                                  {businessCalendar?.[day]?.endTime}
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td scope="col">{t(day)}</td>
                                <td scope="col">{t('Closed')}</td>
                                <td scope="col">{t('Closed')}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        {t('Close')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- CALENDAR  MODAL --> */}
            </div>
          </div>
        </div>
      </div>
      <div class="main-content-area">
        <div class="container">
          <h5 className="cav-section-title">{t('About Us')}</h5>
          {singleData?.about?.split('\n').map((line, index) => (
            <p key={index}>{line}</p>
          ))}
          <p>{singleData?.website}</p>
          <h5 className="cav-section-title">{t('Spare Parts')}</h5>

          <div class="row">
            {singleData?.parts !== undefined ? (
              singleData?.parts.length > 0 ? (
                singleData?.parts.map((item, i) => {
                  const partsDetail = item?.part;
                  const brands = (item?.brands || []).filter(Boolean);
                  return (
                    <div
                      key={item?.sparePartsOwnerPartId || i}
                      className="col-12 col-md-6 col-lg-4 mb-4"
                    >
                      <div className="cav-part-card">
                        <div
                          className="cav-part-name"
                          style={{ textAlign: isRTL ? 'right' : 'left' }}
                        >
                          {L(partsDetail?.name, partsDetail?.nameAr)}
                        </div>
                        {/* "Available brands" label removed per client request (#11) */}
                        <div className="cav-part-brands">
                          {brands.length > 0 ? (
                            brands.map((b, j) => (
                              <span key={b?.brandId || j} className="cav-brand-chip">
                                {L(b?.name, b?.nameAr)}
                              </span>
                            ))
                          ) : (
                            <span className="text-muted">
                              {t('All brands')}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className="text-muted">{t('No parts listed yet.')}</p>
              )
            ) : (
              <div
                className="text-center text-warning"
                style={{
                  position: 'fixed',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              >
                <PageLoader /> <br />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
